import axios from 'axios';
import {BASIC_URL} from "../../enum";

export const translateText = async (text, targetLang, sourceLang = undefined) => {
  if (!text || !/[a-zA-ZäöüÄÖÜß]/.test(text)) {
    return text;
  }

  const token = localStorage.getItem('jwt');

  try {
    const res = await axios.post(`${BASIC_URL}/translate`, {
      text,
      sourceLang: sourceLang.toUpperCase(),
      targetLang: targetLang.toUpperCase()
    }, { headers: { Authorization: `Bearer ${token}` } });
    return res.data.text;
  } catch {
    return text;
  }
};
